import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IGetMisPagos } from '../shared/interfaces/recaudo';
import { Observable } from 'rxjs';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class PagoService {
  readonly baseUrl: string;
  
    constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
      this.baseUrl = `${this.apiUrl}/api/pagos`;
    }
  
    getMisPagos(): Observable<IGetMisPagos[]> {
      return this.http.get<IGetMisPagos[]>(`${this.baseUrl}/mis-pagos`);
    }
}
